var _defs, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew289({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 3.79,
    width: 14,
    height: 8.42
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 3.79,
    x2: 15,
    y2: 12.21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    y1: 3.79,
    x2: 1,
    y2: 12.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew289);
export default __webpack_public_path__ + "static/media/Symbolpack_New_289.4eeeaed80b317f31cbf8d23804052ff3.svg";
export { ForwardRef as ReactComponent };